import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/legal/LegalLayout";
import { openCookiePreferences } from "@/components/CookieConsent";

export const Route = createFileRoute("/cookie-policy")({
  head: () => ({
    meta: [
      { title: "Cookie Policy — FlashWeb Agency" },
      { name: "description", content: "Cookie Policy di FlashWeb: quali cookie utilizza il sito, come modificare o revocare il consenso." },
      { property: "og:title", content: "Cookie Policy — FlashWeb Agency" },
      { property: "og:description", content: "Cookie utilizzati sul sito FlashWeb e gestione del consenso." },
      { property: "og:url", content: "https://www.flash-web.ch/cookie-policy" },
      { name: "robots", content: "index, follow" },
    ],
    links: [{ rel: "canonical", href: "https://www.flash-web.ch/cookie-policy" }],
  }),
  component: CookiePage,
});

function CookiePage() {
  return (
    <LegalLayout title="Cookie Policy" updated="7 luglio 2026">
      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti visitati memorizzano sul tuo dispositivo per far
        funzionare il sito, ricordare le tue preferenze e raccogliere informazioni statistiche o di
        marketing. Alcuni cookie sono impostati direttamente da FlashWeb (prima parte), altri da servizi
        terzi che utilizziamo (terze parti).
      </p>

      <h2>2. Categorie di cookie utilizzati</h2>

      <h3>2.1 Cookie necessari</h3>
      <p>
        Indispensabili per la sicurezza, l'autenticazione e il corretto funzionamento del sito. Vengono
        installati automaticamente e non richiedono consenso. Senza di essi il sito non può funzionare
        correttamente.
      </p>

      <h3>2.2 Cookie funzionali</h3>
      <p>
        Consentono di ricordare le tue preferenze (lingua, valuta, layout scelto) per un'esperienza
        personalizzata. Vengono attivati solo con il tuo consenso.
      </p>

      <h3>2.3 Cookie analytics</h3>
      <p>
        Utilizziamo strumenti come Google Analytics per raccogliere in forma aggregata e pseudonimizzata
        dati sull'uso del sito (pagine viste, durata visita, sorgente di traffico). Ci aiutano a
        migliorare contenuti e performance.
      </p>

      <h3>2.4 Cookie marketing</h3>
      <p>
        Includono pixel e tag di conversione (Google Ads, Meta, LinkedIn) usati per misurare l'efficacia
        delle nostre campagne pubblicitarie e mostrarti annunci pertinenti sui nostri canali e su siti
        terzi. Vengono installati solo previo tuo consenso esplicito.
      </p>

      <h2>3. Come modificare o revocare il consenso</h2>
      <p>
        Puoi modificare in qualsiasi momento le tue preferenze cookie tramite il nostro centro
        preferenze:
      </p>
      <p>
        <button
          type="button"
          onClick={() => openCookiePreferences()}
          className="inline-flex items-center rounded-full bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground no-underline hover:opacity-90"
        >
          Apri preferenze cookie
        </button>
      </p>

      <h2>4. Come disattivare i cookie dal browser</h2>
      <p>
        Puoi bloccare o eliminare i cookie anche dalle impostazioni del tuo browser. Di seguito le guide
        ufficiali:
      </p>
      <ul>
        <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
        <li><a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
        <li><a href="https://support.apple.com/it-it/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Safari</a></li>
        <li><a href="https://support.microsoft.com/it-it/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
      </ul>
      <p>
        La disattivazione dei cookie necessari può compromettere il corretto funzionamento del sito.
      </p>

      <h2>5. Riferimenti</h2>
      <p>
        Per maggiori informazioni sul trattamento dei dati consulta la nostra{" "}
        <a href="/privacy-policy">Privacy Policy</a>.
      </p>
    </LegalLayout>
  );
}
